module.exports = "<div layout=\"row\" flex>\r\n    <mat-checkbox>{{label}}</mat-checkbox>\r\n</div>\r\n"